import type {LangType, TranslatesType} from './types';
import {LANGS} from './types'
export {LANGS} from './types';

export const DEFAULT_LANG = LANGS.RU

const LANGUAGES: Record<LangType, string> = {
    [LANGS.EN]: 'English',
    [LANGS.RU]: 'Русский',
    [LANGS.UK]: 'Українська',
    [LANGS.TR]: 'Türk',
}

const RU = {
  LEFT_ATTEMPTS: 'Осталось попыток',
  CONGRATULATE: 'Поздравляем!',
  YOU_GUESS_ALL_WORDS: 'Вы отгадали все слова!',
  SEE_SOON: 'Скоро появятся новые загадки.',
  TRY_OTHER_LANG: 'А пока попробуй отгадать слова на другом языке.',
  YOU_WIN: 'Вы выиграли!',
  YOU_LOSE: 'Вы проиграли!',
  START_GAME: 'Начать игру',
  NEW_GAME: 'Новая игра',
  FOR_CHOICE_YOU_HAVE: 'Для выбора буквы у вас есть',
  SEC: 'сек',
  PROMPT: 'Подсказка: ',
  GUESS_THE_WORD: 'Отгадай слово!',
  TITLE: 'Виселица Онлайн',
  DONATE: 'Поддержать игру',
  CONTINUE_WITH_AD: 'Продолжить с рекламой',
  CLOSE: 'Закрыть',
  TOP: 'ТОП',
  ...LANGUAGES,
}

const UK = {
  LEFT_ATTEMPTS: 'Залишилося спроб',
  CONGRATULATE: 'Вітаємо!',
  YOU_GUESS_ALL_WORDS: 'Ви відгадали всі слова!',
  SEE_SOON: "Скоро з'являться нові загадки.",
  TRY_OTHER_LANG: 'А поки спробуй відгадати слова іншою мовою.',
  YOU_WIN: 'Ви виграли!',
  YOU_LOSE: 'Ви програли!',
  START_GAME: 'Почати гру',
  NEW_GAME: 'Нова гра',
  FOR_CHOICE_YOU_HAVE: 'Для вибору літери у вас є',
  SEC: 'сек',
  PROMPT: 'Підказка: ',
  GUESS_THE_WORD: 'Відгадай слово!',
  TITLE: 'Шибениця Онлайн',
  DONATE: 'Підтримати гру',
  CONTINUE_WITH_AD: 'Продовжити з рекламою',
  CLOSE: 'Заплющити',
  TOP: 'ТОП',
  ...LANGUAGES,
}

const EN = {
  LEFT_ATTEMPTS: 'There are still attempts left',
  CONGRATULATE: 'Congratulations!',
  YOU_GUESS_ALL_WORDS: 'You guessed all the words!',
  SEE_SOON: 'New riddles are coming soon.',
  TRY_OTHER_LANG: 'In the meantime, try to guess the words in another language.',
  YOU_WIN: 'You win!',
  YOU_LOSE: 'You lose!',
  START_GAME: 'Start game',
  NEW_GAME: 'New game',
  FOR_CHOICE_YOU_HAVE: 'To select a letter you have',
  SEC: 'sec',
  PROMPT: 'Prompt: ',
  GUESS_THE_WORD: 'Guess the word!',
  TITLE: 'Gallow Online',
  DONATE: 'Donate',
  CONTINUE_WITH_AD: 'Continue with ads',
  CLOSE: 'Close',
  TOP: 'TOP',
  ...LANGUAGES,
}

const TR = {
  LEFT_ATTEMPTS: 'Denemeler kaldı',
  CONGRATULATE: 'Tebrikler!',
  YOU_GUESS_ALL_WORDS: 'Tüm kelimeleri tahmin ettiniz!',
  SEE_SOON: 'Yakında daha fazla gizem ortaya çıkacak.',
  TRY_OTHER_LANG: 'Şimdilik başka bir dildeki kelimeleri tahmin etmeye çalış.',
  YOU_WIN: 'Sen kazandın!',
  YOU_LOSE: 'Kaybedersin!',
  START_GAME: 'Oyuna başla',
  NEW_GAME: 'Yeni oyun',
  FOR_CHOICE_YOU_HAVE: 'Harfi seçmek için',
  SEC: 'sn',
  PROMPT: 'İpucu: ',
  GUESS_THE_WORD: 'Kelimeyi tahmin et!',
  TITLE: 'Darağacı Çevrimiçi',
  DONATE: 'Oyunu desteklemek',
  CONTINUE_WITH_AD: 'Reklamlarla devam edin',
  CLOSE: 'Kapat',
  TOP: 'TOP',
  ...LANGUAGES,
}

export const TRANSLATES: TranslatesType = {
  [LANGS.RU]: RU,
  [LANGS.EN]: EN,
  [LANGS.UK]: UK,
  [LANGS.TR]: TR,
}
